<template>
  <NxInput
    name="tipoRenda"
    type="text"
    label="Tipo de Renda:"
    placeholder="Digite o tipo de renda"
    :value="localValue"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputTipoRenda',
  mixins: [useReactiveModelMixin('value')],
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputTipoRenda.vue